export const HomePageFeedCompletedCards = 'HomePageFeedCompletedCards';
